export default {
  // START API DATA
  materialSizes: [],
  originalOptionGroups: [],
  optionGroups: [],
  allOptionGroups: [],
  // END API DATA
  isWebToPrint: null,

  additionalOptions: null,
  selectedAdditionalOption: null,

  initialBind: null,
  currentCroppieImage: null,

  isDataLoaded: false,
  selectedTab: 0,
  selectedVariant: null,
  selectedOptions: {},
  productType: "",
  notes: "",
  enableLowQualityImage: false,

  validCart: false,
  validProof: false,

  // TODO: For making view proof required
  // proofViewed: false,

  // START STEPS
  firstMaterial: null,
  uploadedPhotos: [],
  selectedPhoto: null,
  selectedSize: null,
  selectedFilter: null,
  activeOptionGroup: null,
  selectedOrientation: 'portrait',
  // END STEPS

  // START PREVIEWER
  quantitySelected: 1,
  maxZoom: 10,
  sizeRatio: null,
  cropData: null,
  //END PREVIEWER

  from: '',
  productTitle: ''
};
